export class TopUpCreditAction {
  static readonly type = '[Payment] Top up credit';

  constructor() {
  }
}
